import {RenderingServices, utils} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import {
  CELL_RENDERER_PARAMS,
  CELL_RENDERER_PARAMS_AG,
} from 'src/js/model/cell_renderer_params';

interface OwnProps {
  dateOnly?: boolean;
}

type BaseDateFormatterParamsType = ICellRendererParams & OwnProps;

export interface BaseDateFormatterParamsReturnType
  extends BaseDateFormatterParamsType {
  formattedValue: string;
}

export default function baseDateFormatterParams(
  params: BaseDateFormatterParamsType,
  services: RenderingServices = {}
): BaseDateFormatterParamsReturnType {
  const {intl} = services;
  const {dateOnly = true, value, colDef} = params;

  const formatterParams =
    colDef?.[CELL_RENDERER_PARAMS_AG] || colDef?.[CELL_RENDERER_PARAMS] || {};
  const {shortFormat = true} = formatterParams;

  const formattedValue = utils.DateUtils.getFormattedDate(
    value,
    intl,
    dateOnly,
    shortFormat
  );

  return {...params, formattedValue};
}
